import { render, staticRenderFns } from "./readerTypeInformation.vue?vue&type=template&id=2c5b9c9f&"
import script from "./readerTypeInformation.vue?vue&type=script&lang=js&"
export * from "./readerTypeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports